export const OLDEST_TIME = '2000-01-01T00:00:00.000Z';
